import { createSlice } from "@reduxjs/toolkit";
import _, { range } from "lodash";
import moment from "moment";

export const initialState = {
startDate: moment().startOf("year").year(2023).format("YYYY-MM-DD"),
endDate:moment().format("YYYY-MM-DD"),
range:"[0,0,1]",
selectedCompany: "",
selectedLocation: "all",
};

const brandVoiceSlice = createSlice({
  name: "local",
  initialState,
  reducers: {
    startDateChangeFunction: (state, { payload }) => {
        state.startDate = payload;
    },
    endDateChangeFunction: (state, { payload }) => {
        state.endDate = payload;
    },
    rangeChangeFunction: (state, { payload }) => {
        state.range = payload;
    },
    selectedCompanyChangeFunction: (state, { payload }) => {
        state.selectedCompany = payload;
    },
    selectedLocationChangeFunction: (state, { payload }) => {
        state.selectedLocation = payload;
    }
  },
});

export const {
startDateChangeFunction,
endDateChangeFunction,
rangeChangeFunction,
selectedCompanyChangeFunction,
selectedLocationChangeFunction
} = brandVoiceSlice.actions;
export const localSelector = (state) => state.local;
export default brandVoiceSlice.reducer;

